import React from 'react';
import { Button, Snackbar } from '@mui/material';
import colors from '../../../assets/theme/colors';
import LogMoodModal from '../LogMoodModal';

const MobileMoodFeedback = ({
  modalOpen,
  onModalClose,
  child,
  currentMood,
  onSaveMood,
  onClearMood,
  toastOpen,
  onToastClose,
  toastMessage,
  canUndo,
  onUndoMood,
}) => (
  <>
    <LogMoodModal
      open={modalOpen}
      onClose={onModalClose}
      child={child}
      currentMood={currentMood}
      onSave={onSaveMood}
      onClearMood={onClearMood}
    />

    <Snackbar
      open={toastOpen}
      onClose={onToastClose}
      autoHideDuration={1600}
      message={toastMessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={canUndo ? (
        <Button
          onClick={onUndoMood}
          size="small"
          sx={{
            color: '#FFFFFF',
            textTransform: 'none',
            fontWeight: 800,
            borderRadius: '999px',
            minWidth: 0,
            px: 1.25,
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.12)',
            },
          }}
        >
          Undo
        </Button>
      ) : null}
      ContentProps={{
        sx: {
          borderRadius: 999,
          bgcolor: colors.brand.ink,
          color: '#FFFFFF',
          fontWeight: 800,
          px: 1.5,
          boxShadow: `0 10px 24px ${colors.landing.shadowSoft}`,
        },
      }}
    />
  </>
);

export default MobileMoodFeedback;
